var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-font-inter tw-flex tw-flex-col tw-gap-4 tw-p-5 tw-border-dashed tw-border-2 tw-border-[#D0D4DC] tw-rounded-2xl"},[_c('RiskSelection'),_vm._v(" "),_c('ValuesSelection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }